import { Show, type Component } from "solid-js";
import { PanelLayout } from "@/shared/panel-base";
import { PanelPreview } from "@/shared/panel-primitives";
import { usePanel } from "@/shared/use-panel";
import { useWs } from "@/shared/ws";
import { registerPanel } from "@/panel-registry";

const DefenderPanel: Component = () => {
  const ws = useWs();
  const enabled = () => ws.state.agentFeatures?.defender === true;
  const panel = usePanel(() => ({ isFetching: false, error: null }));

  return (
    <PanelLayout title="Defender / Antivirus" status={panel.status()}>
      <Show
        when={enabled()}
        fallback={
          <PanelPreview
            feature="defender"
            goal="Surveiller l'état de la protection (Windows Defender + AV tiers détecté via SecurityCenter2), lancer un scan, consulter l'historique des menaces, gérer les exclusions."
            tools={[
              {
                name: "defender_status",
                description:
                  "État global : Real-time protection on/off, cloud, tamper, dernière mise à jour des définitions, signature version",
              },
              {
                name: "defender_threats_history",
                description: "Historique des menaces détectées (Get-MpThreatDetection) avec action, sévérité, date",
              },
              {
                name: "defender_scan_start",
                description: "Lance un Quick / Full / Custom scan (requiert userConfirmedAt pour Full)",
              },
              { name: "defender_exclusions_list", description: "Liste des exclusions (paths, processes, extensions)" },
              {
                name: "defender_exclusion_add",
                description: "Ajoute une exclusion (destructif soft — requiert userConfirmedAt)",
              },
              { name: "defender_update_signatures", description: "Force Update-MpSignature" },
              {
                name: "antivirus_third_party",
                description: "AV tiers présents via Win32_SecurityCenter (provider + state)",
              },
            ]}
            notes="Backend agent : CIM direct (plus léger que le module Defender PowerShell) — MSFT_MpComputerStatus / MSFT_MpThreatDetection / MSFT_MpPreference dans root/Microsoft/Windows/Defender. AV tiers via AntiVirusProduct dans root/SecurityCenter2 (provider + productState). Lancement de scan via Start-MpScan (pas d'équivalent CIM propre — exécutable mpcmdrun.exe acceptable aussi). Sur Windows Server : Defender peut être désactivé — afficher gracieusement."
          />
        }
      >
        <div style={{ padding: "12px" }}>Implémentation en cours…</div>
      </Show>
    </PanelLayout>
  );
};

registerPanel("defender", DefenderPanel);
export default DefenderPanel;
